// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"d000f4da","131":"a97f0917","415":"2756b50f","470":"95915b27","475":"d000f4da","724":"80dd8423"}[chunkId] + ".chunk.css";
};